import React from 'react'
import style from './index.module.scss'
import formatDuration from 'lib/format-duration'
interface ITimeDuration {
  duration: number
}

const TimeDuration: React.FC<ITimeDuration> = ({ duration }) => {
  return (
    <div className={style.duration}>
      <div className={style.time}>
        {/* <i className={`DCD_Icon icon_play_1 `} /> */}
        <span>{formatDuration(duration)}</span>
      </div>
    </div>
  )
}
export default TimeDuration
